export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  ABOUT_US: '/about-us',
  TRIMIX: '/trimix',
  ORALMED: '/oral-meds',
  CONTACT_US: '/contact-us',
  DASHBOARD: '/dashboard',
  QUESTIONNAIRES: '/questionnaires/newPatient',
  HEALTH_QUESTIONNAIRES: '/questionnaires/healthQuestionnaire',
  PRODUCTS_BASE: '/products',
  PRODUCTS_LIST: '/products/list',
  PRODUCTS_YOUR_OPTIONS: '/products/yourOptions',
  PRODUCTS_CATEGORY: '/products/category/:subCategory',
  PRODUCT_DETAILS: '/products/details/:productId',
  VENDOR_INFORMATION: '/vendor-information',
  PATIENTS_BILL_OF_RIGHTS: '/patients-bill-of-rights',
  RESET_PASSWORD: '/resetPassword',
  CHECKOUT: '/checkout',
  SELF_SCHEDULE: '/scheduleAppointment',
  NOT_FOUND: '*',
};
